import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { Button } from './Button'
import logo from '../../assets/mechanicaldesign/slslogo.svg'

const NAV_LINKS = [
    { href: '#top', label: 'Home' },
    { href: '#why-choose', label: 'About Us' },
    { href: '#categories', label: 'Products' },
    { href: '#problems', label: 'Services' },
    { href: '#industries', label: 'Industries' },
    { href: '#faqs', label: 'FAQs' },
    { href: '#contact', label: 'Contact' },
]

const useStyles = makeStyles(() => ({
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#fff',
        transition: 'box-shadow .2s ease',
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 24,
        height: 76,
    },
    logo: {
        '& img': { height: 34, width: 'auto', display: 'block' },
    },
    nav: {
        '& ul': {
            display: 'flex',
            gap: 30,
            listStyle: 'none',
            margin: 0,
            padding: 0,
        },
        '@media (max-width: 860px)': {
            position: 'fixed',
            top: 76,
            left: 0,
            right: 0,
            background: '#fff',
            boxShadow: tokens.shadowMd,
            maxHeight: 0,
            overflow: 'hidden',
            transition: `max-height ${tokens.transition}`,
            '&$navOpen': { maxHeight: 500 },
            '& ul': {
                flexDirection: 'column',
                padding: '10px 24px 20px',
                gap: 4,
            },
            '& a': { display: 'block', padding: '12px 0' },
        },
    },
    navOpen: {},
    link: {
        fontWeight: 600,
        fontSize: '.95rem',
        color: '#3C3C46',
        textDecoration: 'none',
        position: 'relative',
        padding: '6px 2px',
        transition: `color ${tokens.transition}`,
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            height: 2,
            width: 0,
            background: tokens.colorPrimary,
            transition: `width ${tokens.transition}`,
        },
        '&:hover, &$active': { color: tokens.colorPrimary },
        '&:hover::after, &$active::after': { width: '100%' },
    },
    active: {},
    headerCta: {
        whiteSpace: 'nowrap',
        padding: '11px 24px',
        '@media (max-width: 860px)': { display: 'none' },
    },
    toggle: {
        display: 'none',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 5,
        width: 40,
        height: 40,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        '@media (max-width: 860px)': { display: 'flex' },
        '& span': {
            display: 'block',
            height: 2,
            width: 24,
            background: '#2B2B2E',
            margin: '0 auto',
            transition: `transform ${tokens.transition}, opacity ${tokens.transition}`,
        },
    },
    toggleSpan1Open: { transform: 'translateY(7px) rotate(45deg)' },
    toggleSpan2Open: { opacity: 0 },
    toggleSpan3Open: { transform: 'translateY(-7px) rotate(-45deg)' },
}))

export function Header() {
    const classes = useStyles()
    const [navOpen, setNavOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const [activeId, setActiveId] = useState('top')

    useEffect(() => {
        function onScroll() {
            setScrolled(window.scrollY > 10)

            const sections = document.querySelectorAll('section[id]')
            const scrollPos = window.scrollY + 140
            let currentId = null
            sections.forEach((section) => {
                if (scrollPos >= section.offsetTop) {
                    currentId = section.getAttribute('id')
                }
            })
            if (currentId) setActiveId(currentId)
        }
        window.addEventListener('scroll', onScroll, { passive: true })
        onScroll()
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <header
            className={classes.header}
            style={{
                boxShadow: scrolled
                    ? '0 4px 18px rgba(20,20,50,0.1)'
                    : '0 2px 12px rgba(20,20,50,0.06)',
            }}
        >
            <Container className={classes.inner}>
                {/* <a href="#top" className={classes.logo}>
                    <img src={logo} alt="SLS logo" />
                </a> */}

                <nav className={`${classes.nav} ${navOpen ? classes.navOpen : ''}`}>
                    <ul>
                        {NAV_LINKS.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className={`${classes.link} ${activeId === link.href.slice(1) ? classes.active : ''}`}
                                    onClick={() => setNavOpen(false)}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* <Button href="#contact" className={classes.headerCta}>
                    Get a Quote
                </Button> */}

                <button
                    className={classes.toggle}
                    aria-label="Toggle navigation"
                    aria-expanded={navOpen}
                    onClick={() => setNavOpen((v) => !v)}
                >
                    <span className={navOpen ? classes.toggleSpan1Open : ''} />
                    <span className={navOpen ? classes.toggleSpan2Open : ''} />
                    <span className={navOpen ? classes.toggleSpan3Open : ''} />
                </button>
            </Container>
        </header>
    )
}
